import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionCheckbox } from 'model/QuestionCheckbox';

export class QuestionCheckboxMapper
  implements PageItemKindMapper<QuestionCheckbox, PageItemApi.QuestionCheckboxEntry>
{
  constructor() {}

  serialize(model: QuestionCheckbox): PageItemApi.QuestionCheckboxEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      options: model.options,
      limitAnswerCount: model.limitAnswerCount,
      required: model.isRequired ? 1 : 0,
      hasOther: model.hasOther ? 1 : 0,
      numberingSkipped: model.numberingSkipped ? 1 : 0,
    };
  }

  deserialize(entry: PageItemApi.QuestionCheckboxEntry): QuestionCheckbox {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      options: (entry.options || []).sort((a, b) => a.position - b.position),
      limitAnswerCount: entry.limitAnswerCount,
      isRequired: Boolean(entry.required),
      hasOther: Boolean(entry.hasOther),
      numberingSkipped: Boolean(entry.numberingSkipped),
      locale: entry.locale,
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionCheckbox;
  }

  supportsDeserialize(entry: PageItemApi.ImageWidgetEntry): boolean {
    return entry.kind === PageItemKind.QuestionCheckbox;
  }
}
